import { render, staticRenderFns } from "./ContactsSection.vue?vue&type=template&id=42fbce59&scoped=true&"
import script from "./ContactsSection.vue?vue&type=script&lang=ts&"
export * from "./ContactsSection.vue?vue&type=script&lang=ts&"
import style0 from "./ContactsSection.vue?vue&type=style&index=0&id=42fbce59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fbce59",
  null
  
)

export default component.exports